exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".img-keepAspect {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n.modal-big {\n    max-width: 80% !important;\n}\n\n.showInModal{\n    padding-left: 5px;\n    padding-top: 0px;\n    padding-right: 5px;\n}\n.img-sizes{\n    width: 400px;  \n    height: auto !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/member-information/member-information.component.css
// module id = 422
// module chunks = 0